import React from 'react';

function Assistance() {
  return (
  
    <body>
    <h1>Term Of Use </h1>

    <p> 1- All the app content is the property of fullhealthinc,</p>

      <p> 2-Content can be used only for recreational purposes</p>
      <p>  3-To copy content and use it on any other app, webstie of platrfom is totally prohibated</p>
    <p>4-the use of the content for any comercial reason is prohibated</p>
<p>5-Our Services do not replace health professional services, and can be used only as a general guidance</p>

</body>
  );
}

export default Assistance;
